import PropTypes from "prop-types"
import React from "react"
import "./card.scss"

const Card = ({ link, onHover, onLeave, text, title }) => {
  return (
    <a
      className="split-sticky-card"
      href={link}
      onMouseEnter={onHover}
      onMouseLeave={onLeave}
    >
      <span className="split-sticky-card--header">
        <h3>{title}</h3>

        <p aria-hidden="true" className="split-sticky-card--link">
          <span>Learn More</span>
          <svg
            aria-hidden="true"
            fill="none"
            height="25"
            viewBox="0 0 24 25"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m12.002 5.244 7 7m0 0-7 7m7-7h-14"
              stroke="#122f4e"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.995"
            />
          </svg>
        </p>
      </span>
      <p>{text}</p>
    </a>
  )
}

Card.propTypes = {
  link: PropTypes.string,
  onHover: PropTypes.func,
  onLeave: PropTypes.func,
  text: PropTypes.string,
  title: PropTypes.string,
}

export default Card
